module.exports = __webpack_public_path__ + "img/logo-cnastore.28981729.svg";